export default "__VITE_ASSET__CSUN3k9Y__"